import React, { useState } from "react";
import "../../../styles/Part6Selection.css";
import Part6Questions from "./Part6Questions";
import { letterQuestions } from "../../../data/part6Questions/letterQuestions";
import { advertisementQuestions } from "../../../data/part6Questions/advertisementQuestions";
import { memoQuestions } from "../../../data/part6Questions/memoQuestions";
import { articleQuestions } from "../../../data/part6Questions/articleQuestions";
import { emailQuestions } from "../../../data/part6Questions/emailQuestions";
import { announcementQuestions } from "../../../data/part6Questions/announcementQuestions";
import { hrEmailQuestions } from "../../../data/part6Questions/hrEmailQuestions";
import { customerEmailQuestions } from "../../../data/part6Questions/customerEmailQuestions";
import { eventEmailQuestions } from "../../../data/part6Questions/eventEmailQuestions";
import { businessEmailQuestions } from "../../../data/part6Questions/businessEmailQuestions";
import { realEstateEmailQuestions } from "../../../data/part6Questions/realEstateEmailQuestions";
import { pressReleaseQuestions } from "../../../data/part6Questions/pressReleaseQuestions";
import { article2Questions } from "../../../data/part6Questions/article2Questions";
import { useSubscriptionStatus } from "../../../hooks/useSubscriptionStatus";
import { freeContent } from "../../../utils/freeContent";
// 다른 카테고리의 문제 데이터도 import

const Part6Selection = ({ isActive, onBack }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategorySelect = (categoryId) => {
    // 구독자인 경우 모든 컨텐츠에 접근 가능
    if (isActive) {
      setSelectedCategory(categoryId);
      return;
    }

    // 비구독자인 경우 무료 컨텐츠 체크
    const freeCategories = freeContent.part6.categories || [];
    const isFreeContent = freeCategories.includes(categoryId);

    if (!isFreeContent) {
      // 구독자가 아니고 무료 콘텐츠도 아니면 접근 불가
      return;
    }

    setSelectedCategory(categoryId);
  };

  const getQuestionsForCategory = (categoryId) => {
    switch (categoryId) {
      case "letter":
        return letterQuestions;
      case "advertisement":
        return advertisementQuestions;
      case "memo":
        return memoQuestions;
      case "article":
        return articleQuestions;
      case "email":
        return emailQuestions;
      case "announcement":
        return announcementQuestions;
      case "letter2":
        return hrEmailQuestions;
      case "customer_email":
        return customerEmailQuestions;
      case "event_email":
        return eventEmailQuestions;
      case "business_email":
        return businessEmailQuestions;
      case "real_estate_email":
        return realEstateEmailQuestions;
      case "press_release":
        return pressReleaseQuestions;
      case "public_announcement":
        return letterQuestions;
      case "article2":
        return article2Questions;
      default:
        return letterQuestions;
    }
  };

  if (selectedCategory) {
    const questions = getQuestionsForCategory(selectedCategory);
    if (!questions || questions.length === 0) {
      return <div>No questions available for this category.</div>;
    }
    return (
      <Part6Questions
        questions={questions}
        onBack={() => setSelectedCategory(null)}
      />
    );
  }

  const categories = [
    {
      id: "business_email",
      title: "Business Email",
      description: "사업 및 비즈니스 관련 이메일 글",
    },
    {
      id: "event_email",
      title: "Event Email",
      description: "행사 관련 이메일 글",
    },
    {
      id: "letter2",
      title: "HR Email",
      description: "인사 관련 이메일 글",
    },
    {
      id: "advertisement",
      title: "Advertisement",
      description: "광고문 관련 글",
    },
    {
      id: "memo",
      title: "Memo & Notice",
      description: "메모 & 알림 관련 글",
    },
    {
      id: "email",
      title: "Text Message",
      description: "대화형 및 텍스트메시지 관련 글",
    },
    {
      id: "announcement",
      title: "Announcement",
      description: "공지사항 관련 글",
    },
    {
      id: "customer_email",
      title: "Customer Email",
      description: "고객 서비스 관련 이메일 글",
    },
    {
      id: "press_release",
      title: "Press Release",
      description: "보도자료",
    },
    {
      id: "article2",
      title: "Article ",
      description: "기사",
    },
  ];

  return (
    <div className="part6-selection-container">
      <div className="part6-selection-header">
        <h2>Part 6 & 7 - Reading Practice</h2>
      </div>
      <div className="practice-description">
        <p>
          토익몬에서는 문제 자체보다 영어 어순대로 글을 읽는 훈련에 중점을 두고
          있습니다. 실제 시험에서 가장 효과적인 학습은 ETS 기출문제를 푸는
          것이기 때문에, 실제 기출문제는 종이로 풀어보시길 권장합니다.
        </p>
        <p>
          하지만 기출문제를 풀기 전에 이곳의 글을 반드시{" "}
          <strong>왼쪽에서 오른쪽으로 영어 어순대로</strong> 읽는 훈련을 하시면
          실제 시험에서 더 좋은 결과를 얻으실 수 있습니다.
        </p>
      </div>
      <div className="part6-categories">
        {categories.map((category) => {
          const freeCategories = freeContent.part6.categories || [];
          const isFreeContent = freeCategories.includes(category.id);

          return (
            <div
              key={category.id}
              className={`category-card ${
                !isActive && !isFreeContent ? "premium" : ""
              }`}
              onClick={() => handleCategorySelect(category.id)}
            >
              <h3>{category.title}</h3>
              <p>{category.description}</p>
              {!isActive && !isFreeContent && (
                <div className="lock-overlay">
                  <img src="/icons/lock.svg" alt="잠김" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Part6Selection;
